<app-header [widgets]="header?.widgets"></app-header>

<section class="container d-flex pe-0" #container>
  <sidebar [widgets]="nav?.widgets" class="p-lr-10" style="width: 25%"></sidebar>
  <app-main-frame class="main-frame p-lr-10" [widgets]="main?.widgets" style="width: 75%"></app-main-frame>
</section>

<app-footer [widgets]="footer?.widgets"></app-footer>

<a
  #scrollOnTopButton
  href="#"
  style="z-index: 9999999"
  aria-hidden="true"
  tabindex="-1"
  data-bs-toggle="backtotop"
  class="back-to-top back-to-top-small"
>
  <i class="bi bi-chevron-up" style="font-size: 24px"></i>
</a>
